export default __webpack_public_path__ + "static/media/card_segurador_brasil.b85baf82.webp";